import * as c from "purify-ts/Codec";

export type localStorageSpec<T> = {
  key: string;
  codec: c.Codec<T>;
};

export function getFromLocalStorage<T>(spec: localStorageSpec<T>): T | null {
  const val = localStorage.getItem(spec.key);
  if (val === null) {
    return null;
  } else {
    try {
      const parsed: unknown = JSON.parse(val);
      const decoded = spec.codec.decode(parsed);
      return decoded.caseOf({
        Left: (err) => {
          console.error(
            `Failed to decode Localstorage value. key: ${spec.key}, value: ${val}. err: ${err}`,
          );
          return null;
        },
        Right: (t) => t,
      });
    } catch {
      console.error(
        `Failed to parse Localstorage value. key: ${spec.key}, value: ${val}`,
      );
      return null;
    }
  }
}

export function setLocalStorage<T>(spec: localStorageSpec<T>, value: T): void {
  localStorage.setItem(spec.key, JSON.stringify(spec.codec.encode(value)));
}
